export const LOCALES = {
    ENGLISH: 'en',
    JAPANESE: 'jpn'
}